<script setup lang="ts">
import Button from 'primevue/button';
import { Stack, Typography } from '@apparatix/library/core';

type Props = {
  buttonLabel: string;
  buttonIcon: string;
}

const props = defineProps<Props>();

const emit = defineEmits<{
  (e: 'action-click'): void;
}>();
</script>
<template>
  <Stack class="items-center">
    <svg
      width="180"
      height="177"
      viewBox="0 0 180 177"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M76.4757 12.3322C78.191 5.93062 84.7711 2.13162 91.1727 3.84692L168.409 24.5423C174.81 26.2576 178.609 32.8376 176.894 39.2392L156.199 116.475C154.483 122.877 147.903 126.676 141.502 124.961L64.2656 104.265C57.864 102.55 54.065 95.97 55.7803 89.5684L76.4757 12.3322Z" fill="#E0E7FF" />
      <path d="M33.6001 45.1562C33.6001 38.5288 38.9727 33.1562 45.6001 33.1562H125.6C132.227 33.1562 137.6 38.5288 137.6 45.1562V125.156C137.6 131.784 132.227 137.156 125.6 137.156H45.6001C38.9727 137.156 33.6001 131.784 33.6001 125.156V45.1562Z" fill="#C7D2FE" />
      <path d="M3.10583 87.4316C1.39053 81.03 5.18952 74.45 11.5911 72.7347L88.8273 52.0393C95.2289 50.324 101.809 54.123 103.524 60.5246L124.22 137.761C125.935 144.162 122.136 150.742 115.734 152.458L38.4982 173.153C32.0966 174.868 25.5165 171.069 23.8012 164.668L3.10583 87.4316Z" fill="#A5B4FC" />
      <path
        d="M64 113.956L116 165.956"
        stroke="#6366F1"
        stroke-width="12"
        stroke-linecap="round"
      />
      <circle
        cx="63.6001"
        cy="114.356"
        r="24"
        fill="white"
        stroke="#6366F1"
        stroke-width="12"
      />
    </svg>
    <Typography variant="body">
      Looks like there&rsquo;s nothing here
    </Typography>
    <Button :icon="props.buttonIcon" :label="props.buttonLabel" @click="emit('action-click')" />
  </Stack>
</template>
